export const colorMappings: Record<string, string> = {
  silver: '#C0C0C0',
  pink: '#FFC0CB',
  green: '#008000',
  blue: '#0000FF',
  spacegray: '#808080',
  midnightgreen: '#004953',
  gold: '#FFD700',
  black: '#000000',
  yellow: '#FFFF00',
  white: '#FFFFFF',
  purple: '#800080',
  red: '#FF0000',
  stormgrey: '#4F4F4F',
  mysticblack: '#000000',
  mysticbronze: '#CD7F32',
  mysticnavy: '#000080',
};
